<h2 mat-dialog-title>Resumo do Plano</h2>

<mat-dialog-content class="summary-dialog-content">
  <div class="summary-container">
    <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="16px">
      <div fxFlex="1 1 50%" fxFlex.xs="100" fxFlex.sm="100">
        <div class="summary-card">
          <div class="summary-card-header">
            <mat-icon>assignment</mat-icon>
            <h3>Plano</h3>
          </div>
          <div class="summary-card-content">
            <div class="info-grid plan-info-grid">
              <div class="info-item">
                <span class="info-label">Nome:</span>
                <span class="info-value">{{ selectedPlan?.name || '--' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Tipo:</span>
                <span class="info-value">{{ getSystemTypeDescription(selectedPlan?.type) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Variações:</span>
                <span class="info-value">{{ selectedPlan?.variations?.length || 0 }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Qt. Acessos:</span>
                <span class="info-value">{{ selectedPlan?.terminalQuantity ?? selectedPlan?.accessQuantity ?? '--' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Tipo de Acesso:</span>
                <span class="info-value">{{ selectedPlan?.accessType || '--' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Comissão:</span>
                <span class="info-value">{{ selectedPlan?.payCommission ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">HTML:</span>
                <span class="info-value">{{ selectedPlan?.htmlEnabled ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div fxFlex="1 1 50%" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="16px">
          <div fxFlex="1 1 50%" fxFlex.xs="100" fxFlex.sm="100" class="summary-card">
            <div class="summary-card-header">
              <mat-icon>computer</mat-icon>
              <h3>Sistema</h3>
            </div>
            <div class="summary-card-content">
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Solução:</span>
                  <span class="info-value" *ngIf="selectedSolutions.length === 0">--</span>
                  <span class="info-value" *ngIf="selectedSolutions.length > 0">
                    <div *ngFor="let solution of selectedSolutions">{{ solution }}</div>
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">Tipo:</span>
                  <span class="info-value">{{ getSystemTypeDescription(systemType) }}</span>
                </div>
              </div>
            </div>
          </div>

          <div fxFlex="1 1 50%" fxFlex.xs="100" fxFlex.sm="100" class="summary-card highlight">
            <div class="summary-card-header">
              <mat-icon>table_rows</mat-icon>
              <h3>Variações do Plano</h3>
            </div>
            <div class="summary-card-content">
              <div class="variations-table-wrapper">
                <table class="variations-table">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Solução</th>
                      <th>Valor de Acesso</th>
                      <th *ngIf="!isPartnerUser">Custo</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let variation of variationRows">
                      <td>{{ variation?.codigo || '--' }}</td>
                      <td>{{ variation?.solucao || variation?.systemName || '--' }}</td>
                      <td>{{ (variation?.valorMensalidade ?? variation?.valuePerAccess ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</td>
                      <td *ngIf="!isPartnerUser">{{ (variation?.custo ?? variation?.cost ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</td>
                      <td>{{ variation?.status || '--' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="values-list totals-inline">
                <div class="value-item">
                  <span>Total Plano:</span>
                  <span>{{ totalPlanValue | currency:'BRL':'symbol':'1.2-2' }}</span>
                </div>
                <div class="value-item" *ngIf="!isPartnerUser">
                  <span>Total Custo:</span>
                  <span>{{ totalCost | currency:'BRL':'symbol':'1.2-2' }}</span>
                </div>
                <div class="value-item total">
                  <span>Total Geral:</span>
                  <span>{{ getTotalValue() | currency:'BRL':'symbol':'1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modules-card">
          <div class="modules-header">
            <div class="header-title">
              <mat-icon>extension</mat-icon>
              <h3>Módulos Selecionados ({{ modules.length }})</h3>
            </div>
          </div>
          <div class="selected-modules-list" *ngIf="modules.length > 0; else noModules">
            <div *ngFor="let module of modules; let i = index" class="selected-module-item">
              <div class="module-number">{{ i + 1 }}</div>
              <div class="module-details">{{ module?.name || module }}</div>
            </div>
          </div>
          <ng-template #noModules>
            <p class="empty">Nenhum módulo vinculado.</p>
          </ng-template>
        </div>

      </div>
    </div>

    <div class="modules-card">
      <div class="modules-header">
        <div class="header-title">
          <mat-icon>groups</mat-icon>
          <h3>Parceiros Selecionados</h3>
        </div>
      </div>
      <div class="selected-modules-list" *ngIf="selectedPartners.length > 0; else noPartners">
        <div *ngFor="let partner of selectedPartners; let i = index" class="selected-module-item">
          <div class="module-number">{{ i + 1 }}</div>
          <div class="module-details">{{ partner?.name || '--' }}</div>
        </div>
      </div>
      <ng-template #noPartners>
        <p class="empty">Nenhum parceiro vinculado.</p>
      </ng-template>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">Fechar</button>
</mat-dialog-actions>
